import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import BoxTextTemplateService from "./box-text-template.service";

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    '$uibModal',
    'BoxTextTemplateService'
];

class BoxTemplateController {
    constructor($scope,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                $uibModal,
                BoxTextTemplateService) {

        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.$uibModal = $uibModal;
        this.BoxTextTemplateService = BoxTextTemplateService;
        this.responseText = '';
    }

    $onInit() {

        this.BoxTextTemplateService.getComponentTextInfo(this.page).then(response => {

            if(response.length > 0){
                this.responseText = response[0].contenido;
            }

        }).catch(reason => {
            let options = {
                title: '',
                isHtml: false,
                content: 'Ha ocurrido un error obtener la informacion',
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);
        });

    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

BoxTemplateController.$inject = inject;

export default BoxTemplateController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/box-text-template/box-text-template.controller.js
 **/